module.exports = __webpack_public_path__ + "img/Dashboard-Member.d53bef41.svg";